import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/admin/qairBouns/list',
      data
    });
  },
  getPairs(data) {
    return http.get({
      url: '/admin/tradePair/allDisplay',
      data
    });
  },
  addPairBonus(data) {
    return http.post({
      url: '/admin/qairBouns/addOrUpdate',
      data,
      dataType: 'form'
    });
  },

  getPairBounsRecordList(data) {
    return http.get({
      url: '/admin/pairBouns/pairBounsRecordList',
      data
    });
  },
  pairBounsCalculat(data) {
    return http.post({
      url: '/admin/pairBouns/calculation',
      data,
      dataType: 'form'
    });
  },
  getPairBounsRecordDetailList(data) {
    return http.get({
      url: '/admin/pairBouns/pairBounsRecordDetailList',
      data
    });
  },
  getPublicUserInfo(data) {
    return http.get({
      url: '/admin/pairBouns/publicUserInfo',
      data
    });
  },

  getSearchPairBouns(data) {
    return http.get({
      url: '/admin/pairBouns/searchPairBouns',
      data
    });
  },

  pairBounsAddOrUpdate(data) {
    return http.post({
      url: '/admin/pairBouns/addOrUpdate',
      data
    });
  },
  pairBounsGrant(data) {
    return http.post({
      url: '/admin/pairBouns/grant',
      data,
      dataType: 'form'
    });
  }
};
